import { render, staticRenderFns } from "./SharePositionLanding.vue?vue&type=template&id=2c3d546c&scoped=true&"
import script from "./SharePositionLanding.vue?vue&type=script&lang=js&"
export * from "./SharePositionLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3d546c",
  null
  
)

export default component.exports